import "../../scss/_document_create_modal.scss";
import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'editor',
    ];

    isEnabled = null;

    openingModalController = null;

    open(template) {
        $(this.element).modal({
            show: true,
        });

        $(this.editorTarget).summernote({
            toolbar: [
                ['style', ['bold', 'italic']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['toggleEditor'],
            ],
            tooltip: false,
            disableResizeEditor: true,
            buttons: {
                toggleEditor: () => {
                    const ui = $.summernote.ui;

                    const button = ui.button({
                        contents: this.editorTarget.dataset.toggleEditorIconHtml,
                        click: () => {
                            this.toggleEditor();
                        },
                    });

                    return button.render();
                },
            },
        });

        this.isEnabled = true;

        $(this.editorTarget).summernote('code', template);

        this.disableEditor();
    }

    disableEditor() {
        $(this.editorTarget).summernote('disable');

        this.isEnabled = false;

        const button = $('.note-toggleEditor').find('button');

        button.prop('disabled', false);
        button.removeClass('disabled');

        $('#create-new-document-modal .note-editable')[0].style.setProperty('background-color', '#e9ecef', 'important');
    }

    enableEditor() {
        $(this.editorTarget).summernote('enable');

        this.isEnabled = true;

        $('#create-new-document-modal .note-editable')[0].style.setProperty('background-color', '#fff', 'important');
    }

    toggleEditor() {
        this.isEnabled ? this.disableEditor() : this.enableEditor();
    }

    close() {
        $(this.element).modal('hide');

        this.openingModalController.show();
    }

    create() {
        if (this.openingModalController.hasDocumentCreateOrUploadOutlet) {
            const outlet = this.openingModalController.documentCreateOrUploadOutlet;

            $(outlet.documentContainerCreateOrUploadTarget).css('display', 'none');
            $(outlet.documentContainerInfoAndActionsTarget).css('display', 'flex');
            $(outlet.feeDocumentEditTarget).css('display', 'block');
            $(outlet.feeDocumentFileNameTarget).text('Conventiond’honoraires.pdf');
            $(outlet.bookingDocumentHtmlTarget).val($(this.editorTarget).summernote('code'));

            this.close();

            addAlert('success', translations['payment_popup.Document created successfully']);
        } else {
            this.close();
            this.openingModalController.showDataPreviewStep();
            $(this.openingModalController.bookingDocumentHtmlTarget).val($(this.editorTarget).summernote('code'));
        }
    }
}
